/* ---------------------------------------------------------------------------
 * Product recommendations — carousel layout
 *
 * The <product-recommendations> element in global.js replaces its own
 * innerHTML with the fetched section markup and fires no event, so we watch it
 * with a MutationObserver instead of hooking into the base theme.
 *
 * Desktop and mobile carousels are independent settings: whichever breakpoint
 * has the carousel turned off falls back to the Madrid grid, so Swiper is
 * created and destroyed as the 750px boundary is crossed rather than being
 * left running behind a CSS override.
 * ------------------------------------------------------------------------ */
(function () {
  var DESKTOP_QUERY = '(min-width: 750px)';
  var WIDE_QUERY = 1100;
  var BREAKPOINT = 750;

  var desktopMq = window.matchMedia(DESKTOP_QUERY);

  function num(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) || parsed <= 0 ? fallback : parsed;
  }

  function build(el) {
    var root = el.closest('.product-recommendations') || document;
    var desktopColumns = num(el.dataset.columnsDesktop, 4);
    var mobileColumns = num(el.dataset.columnsMobile, 2);
    var breakpoints = {};

    // Between 750 and 1100 the Figma desktop count is too tight, so cap it.
    breakpoints[BREAKPOINT] = {
      slidesPerView: Math.min(3, desktopColumns),
      spaceBetween: 4,
    };
    breakpoints[WIDE_QUERY] = {
      slidesPerView: desktopColumns,
      spaceBetween: 4,
    };

    return new Swiper(el, {
      slidesPerView: mobileColumns,
      spaceBetween: 8,
      speed: 600,
      watchOverflow: true,
      threshold: 4,
      navigation: {
        prevEl: root.querySelector('.pr-arrow--prev'),
        nextEl: root.querySelector('.pr-arrow--next'),
        disabledClass: 'is-disabled',
        lockClass: 'is-locked',
      },
      breakpoints: breakpoints,
    });
  }

  function sync(scope) {
    if (typeof Swiper === 'undefined') return;

    var elements = (scope || document).querySelectorAll('.pr-carousel');

    Array.prototype.forEach.call(elements, function (el) {
      var wanted = desktopMq.matches
        ? el.dataset.carouselDesktop === 'true'
        : el.dataset.carouselMobile === 'true';

      if (wanted) {
        el.classList.add('is-carousel');
        if (!el.swiper) build(el);
      } else {
        if (el.swiper) el.swiper.destroy(true, true);
        el.classList.remove('is-carousel');
      }
    });
  }

  var observed = new WeakSet();

  function watch(host) {
    if (observed.has(host)) return;
    observed.add(host);
    new MutationObserver(function () {
      sync(host);
    }).observe(host, { childList: true });
  }

  function boot(scope) {
    var hosts = (scope || document).querySelectorAll('product-recommendations');
    Array.prototype.forEach.call(hosts, watch);
    sync(scope);
  }

  function start() {
    boot(document);

    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', function () {
        sync(document);
      });
    } else if (desktopMq.addListener) {
      desktopMq.addListener(function () {
        sync(document);
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) boot(event.target);
    });
  }

  if (typeof Swiper === 'undefined') {
    window.addEventListener('load', start, { once: true });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
